import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgManageTaskGroups = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M3 21V16.5335H4.5784V7.46649H3V3H7.46649V4.5784H16.5335V3H21V7.46649H19.4216V16.5335H21V21H16.5335V19.4216H7.46649V21H3ZM7.46649 18.1119H16.5335V16.5335H18.1119V7.46649H16.5335V5.88809H7.46649V7.46649H5.88809V16.5335H7.46649V18.1119ZM4.30969 6.1568H6.1568V4.30969H4.30969V6.1568ZM17.8432 6.1568H19.6903V4.30969H17.8432V6.1568ZM17.8432 19.6903H19.6903V17.8432H17.8432V19.6903ZM4.30969 19.6903H6.1568V17.8432H4.30969V19.6903Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M11.0512 15.2238L16.1867 10.1153L15.1834 9.11191L11.0512 13.2171L9.21462 11.4076L8.23828 12.4109L11.0512 15.2238Z",
		fill: "currentColor"
	})]
});
export default SvgManageTaskGroups;
